import Phaser from 'phaser'

class GameScene extends Phaser.Scene {
    constructor() {
        super({ key: "FireGame" })
        this.intro_shown = false;
        this.delay_tmer = 4000;
    }

    preload() {
        this.load.image('bg', '/assets/bg.png')
        this.load.image('bg-gameover', '/assets/game-over.png')
        this.load.image('intro', '/assets/intro.png')
        this.load.image('container', '/assets/controls_container.png')
        this.load.image('analog_container', '/assets/analog_container.png')
        this.load.image('analog', '/assets/analog.png')
        this.load.image('right_arrow', '/assets/right_arrow.png')
        this.load.image('left_arrow', '/assets/left_arrow.png')
        this.load.image('fire_button', '/assets/fire_button.png')

        this.load.image('player', '/assets/shapes/player.png')
        this.load.image('germ1', '/assets/shapes/germ1.png')
        this.load.image('germ2', '/assets/shapes/germ2.png')
        this.load.image('germ3', '/assets/shapes/germ3.png')
        // this.load.image('germ4', '/assets/shapes/germ4.png')
        // this.load.image('germ5', '/assets/shapes/germ5.png')
        // this.load.image('germ6', '/assets/shapes/germ6.png')
        // this.load.image('germ7', '/assets/shapes/germ7.png')
        // this.load.image('germ8', '/assets/shapes/germ8.png')
        this.load.image('fire', '/assets/shapes/fire.png')
        this.load.json('shapes', '/assets/shapes/shapes.json');

        this.load.audio('gameSound', '/assets/sounds/game_sound.mp3');
        this.load.audio('popSound', '/assets/sounds/pop.mp3');
        this.load.audio('gameOver', '/assets/sounds/game_over.mp3');
    }

    create() {

        // document.getElementById('game-intro').style.display = 'none'


        this.input.keyboard.enabled = true;

        if (!this.gameSound) {
            this.gameSound = this.sound.add('gameSound', { loop: true, volume: 0.7 });
        }
        if (!!this.intro_shown) {
            this.gameSound.play();
        }

        // if (!this.popSound) {
        //     this.popSound = this.sound.add('popSound', { loop: false, volume: 1, detune: Phaser.Math.Between(-100, 100) });
        // }

        if (!this.gameOverSound) {
            this.gameOverSound = this.sound.add('gameOver', { loop: false, volume: 1, detune: Phaser.Math.Between(-100, 100) });
        }

        /** Load Shapes */
        this.shapes = this.cache.json.get('shapes');
        this.enemyKeys = ['germ1', 'germ2', 'germ3']

        this.cameras.main.setBackgroundColor(0x28307A)
        this.input.addPointer(2);

        this.bgWidth = this.scale.width <= 768 ? this.scale.width - 50 : 400;
        this.bgHeight = Math.min(2.5 * (this.scale.height / 4), (4 * this.bgWidth) / 3)
        this.bgOriginX = (this.scale.width / 2);
        this.bgOriginY = this.scale.width <= 768 ? this.bgHeight / 2 + 30 : Math.max(this.bgHeight / 2, this.scale.height / 2 - this.bgHeight / 3);

        this.background = this.add.image(this.bgOriginX, this.bgOriginY, 'bg');
        this.background.setDisplaySize(
            this.bgWidth, this.bgHeight
        )


        const worldBoundsX = this.bgOriginX - (this.bgWidth / 2);
        const worldBoundsY = this.bgOriginY - (this.bgHeight / 2);
        const worldBoundsWidth = this.bgWidth;
        const worldBoundsHeight = this.bgHeight;
        this.worldBounds = {
            min: { x: worldBoundsX, y: worldBoundsY },
            max: { x: worldBoundsX + worldBoundsWidth, y: worldBoundsY + worldBoundsHeight }
        };
        this.matter.world.setBounds(
            worldBoundsX,
            worldBoundsY,
            worldBoundsWidth,
            worldBoundsHeight,
        )


        this.containerWidth = this.bgWidth
        this.containerHeight = this.bgHeight / 2
        this.containerOriginX = this.bgOriginX;
        this.containerOriginY = this.scale.height - (this.containerHeight / 2);
        this.controlsContainer = this.add.image(this.containerOriginX, this.containerOriginY, 'container')
        this.controlsContainer.setDisplaySize(this.containerWidth, this.containerHeight)


        /** Controls Container Configuration */
        this.analogContainerOriginX = this.containerOriginX - (this.containerWidth / 4.8)
        this.analogContainerOriginY = this.containerOriginY
        this.analogContainerWidth = Math.min(this.containerWidth * 0.4, this.containerHeight * 0.7)
        this.analogContainerHeight = this.analogContainerWidth
        this.analogContainer = this.add.image(this.analogContainerOriginX, this.analogContainerOriginY, 'analog_container')
        this.analogContainer.setDisplaySize(this.analogContainerWidth, this.analogContainerHeight)



        // /** Fire Button Configuration */
        this.fireButtonOriginX = this.containerOriginX + (this.containerWidth / 4)
        this.fireButtonOriginY = this.containerOriginY
        this.fireButtonWidth = Math.min(this.containerWidth * 0.3, this.containerHeight * 0.55)
        this.fireButtonHeight = this.fireButtonWidth
        this.fireButton = this.add.image(this.fireButtonOriginX, this.fireButtonOriginY, 'fire_button')
        this.fireButton.setDisplaySize(this.fireButtonWidth, this.fireButtonHeight)
        this.fireButton.setInteractive();

        // Add click event
        this.fireButton.on('pointerdown', () => this.spawnFire());
        this.input.keyboard.on('keydown-SPACE', () => this.spawnFire());




        /** Analog Arrow Configuration */
        this.arrowWidth = this.analogContainerWidth * 0.08
        this.arrowHeight = (1.7 * this.arrowWidth)
        this.arrowOriginY = this.analogContainerOriginY
        this.leftArrowOriginX = this.analogContainerOriginX - (this.analogContainerWidth / 2) - (this.arrowWidth)
        this.rightArrowOriginX = this.analogContainerOriginX + (this.analogContainerWidth / 2) + (this.arrowWidth)


        this.arrowRight = this.add.image(this.rightArrowOriginX, this.arrowOriginY, 'right_arrow')
        this.arrowLeft = this.add.image(this.leftArrowOriginX, this.arrowOriginY, 'left_arrow')
        this.arrowRight.setDisplaySize(this.arrowWidth, this.arrowHeight)
        this.arrowLeft.setDisplaySize(this.arrowWidth, this.arrowHeight)



        /** Analog Configuration */
        this.analogOriginX = this.analogContainerOriginX
        this.analogOriginY = this.analogContainerOriginY
        this.analogWidth = this.analogContainerWidth / 2
        this.analogHeight = this.analogWidth
        this.analog = this.add.image(this.analogOriginX, this.analogOriginY, 'analog')
        this.analog.setDisplaySize(this.analogWidth, this.analogHeight)

        // Enable input detection and dragging
        this.analog.setInteractive({ draggable: true });

        // Drag Events
        this.input.setDraggable(this.analog);

        this.input.on('drag', (...params) => this.anaglogDragStart(...params));

        this.input.on('dragend', (...params) => this.anaglogDragEnd(...params));


        this.input.keyboard.on('keydown-RIGHT', () => this.keyboardRight());
        this.input.keyboard.on('keyup-RIGHT', () => this.keyRelease());

        this.input.keyboard.on('keydown-LEFT', () => this.keyboardLeft());
        this.input.keyboard.on('keyup-LEFT', () => this.keyRelease());


        this.playerOriginX = this.bgOriginX + 10;
        this.playerOriginY = this.bgOriginY + (this.bgHeight / 2) - 60;
        this.playerWidth = this.bgWidth / 6
        this.playerHeight = this.bgHeight / 6
        this.playerMaxVelocity = 4;

        this.player = this.matter.add.image(this.playerOriginX, this.playerOriginY, 'player', null, {
            shape: this.shapes.player,
            inertia: Infinity, // Prevents rotation due to collisions
            frictionAir: 0, // No air resistance
            friction: 0, // No surface friction
            frictionStatic: 0,// No static friction
        })
        this.player.setDisplaySize(this.playerWidth, this.playerHeight)
        this.player.setVelocity(0, 0)
        this.player.setIgnoreGravity(true);
        this.player.setFixedRotation(); // Prevents rotation
        this.player.setAngularVelocity(0); // Stops angular movement

        this.enemyGroup = [];
        this.fireGroup = [];


        // this.matterCollision.addOnCollideStart({
        //     objectA: this.enemyGroup,
        //     objectB: this.fireGroup,
        //     callback: (eventData) => {
        //         console.log('Fire hit the enemy!');
        //     }
        // });

        // this.matterCollision.addOnCollideStart({
        //     objectA: this.enemyGroup,
        //     objectB: this.player,
        //     callback: (eventData) => {
        //         console.log('Enemy hit player!');
        //     }
        // });





        // this.fireRespawnEvent = this.time.addEvent({
        //     delay: 500,
        //     callback: this.spawnFire,
        //     callbackScope: this,
        //     loop: true
        // })

        this.matter.world.on('collisionstart', this.handleCollisions, this);

        this.score = 0;

        this.scoreOriginX = (this.bgOriginX - (this.bgWidth / 2)) + 20;
        this.scoreOriginY = (this.bgOriginY - (this.bgHeight / 2)) + 15;

        // Add a text object to display the score
        this.scoreText = this.add.text(this.scoreOriginX, this.scoreOriginY, '0', {
            fontSize: '36px',
            fontFamily: 'Arial',
            color: '#FF0000',
            stroke: '#000000',
            strokeThickness: 2
        });

        const intro = document.getElementById('game-intro');
        this.time.delayedCall(this.delay_tmer, () => {
            if (intro) intro.style.display = 'none';
            this.intro_shown = true;
            if (!this.gameSound.isPlaying) {
                this.gameSound.play();
            }

            this.enemyRespawnEvent = this.time.addEvent({
                delay: 500,
                callback: this.spawnEnemy,
                callbackScope: this,
                loop: true
            })
        });


        this.scale.on('resize', this.resize, this)
    }



    spawnEnemy() {
        const enemySize = {
            width: 40,
            height: 40
        }

        const x = Phaser.Math.Between(this.worldBounds.min.x + (enemySize.width / 2), this.worldBounds.max.x - (enemySize.width / 2));
        const y = this.worldBounds.min.y + enemySize.height / 2;

        const germIndex = Math.floor(Math.random() * this.enemyKeys.length) + 1
        const germName = this.enemyKeys[germIndex - 1]
        const enemy = this.matter.add.sprite(x, y, germName, null, {
            isStatic: false,
            shape: this.shapes[germName],
            frictionAir: 0, // Remove air resistance
            friction: 0,     // Remove surface friction
            frictionStatic: 0,
            restitution: 0,
        });
        enemy.setDisplaySize(enemySize.width, enemySize.height)
        enemy.setVelocity(0, 2.5)
        enemy.setIgnoreGravity(true)
        this.enemyGroup.push(enemy)
    }

    spawnFire() {
        const fireSize = 20

        const x = this.player.x - (this.playerWidth / 20);
        const y = this.playerOriginY - (this.playerHeight / 2) - 8;

        const fire = this.matter.add.sprite(x, y, 'fire', null, {
            isStatic: false,
            shape: { type: 'circle', radius: fireSize / 2 },
            frictionAir: 0, // Remove air resistance
            friction: 0,     // Remove surface friction
            frictionStatic: 0,
            restitution: 0,   // Make it bounce perfectly (optional)
        })
        fire.setDisplaySize(fireSize, fireSize)
        fire.setVelocity(0, -4)
        this.sound.play('popSound', {
            volume: 1,
            loop: false,
            detune: Phaser.Math.Between(-100, 100),
        });
        // For illustration purposes, adding pixel-perfect collision:
        // fire.body.setCollisionCategory(1);


    }


    handleCollisions(event) {
        event.pairs.forEach((pair) => {
            const { bodyA, bodyB } = pair;

            // Get game objects
            const objectA = bodyA.gameObject;
            const objectB = bodyB.gameObject;

            if (!objectA && objectB) {
                if (objectB.texture.key !== "player") {
                    this.destroyObject(objectB)
                }
                else {
                    this.player.setVelocity(0, 0)
                }
            }
            else if (objectA && !objectB) {
                if (objectA.texture.key !== "player") {
                    this.destroyObject(objectA)
                }
                else {
                    this.player.setVelocity(0, 0)
                }
            }
            else if (objectA && objectB) {
                const isEnemy = this.enemyKeys.includes(objectA.texture.key) || this.enemyKeys.includes(objectB.texture.key)
                const isPlayer = objectA.texture.key === "player" || objectB.texture.key === "player"
                const isFire = objectA.texture.key === "fire" || objectB.texture.key === "fire"
                // Example: Detect collision between enemy and player
                if (isEnemy && isPlayer) {
                    this.gameOver();
                }
                else if (isEnemy && isFire) {
                    this.destroyObject(objectA)
                    this.destroyObject(objectB)
                    this.score += 1;
                    this.scoreText.setText(this.score);
                }
            }
        });
    }

    destroyObject(object) {
        if (!object || !object.texture) return;

        const key = object.texture.key;

        if (key !== "player") {
            // Remove from enemy group
            this.enemyGroup = this.enemyGroup.filter(enemy => enemy !== object);

            // Remove from fire group
            this.fireGroup = this.fireGroup.filter(fire => fire !== object);

            object.destroy(); // Destroy the sprite
        }
    }

    anaglogDragStart(pointer, gameObject, dragX, dragY) {
        const bounds = this.analogContainer.getBounds();
        const width = this.analogContainerWidth;
        const originY = this.analogContainerOriginY;

        const BOUND_REDUCE = 40
        const min = bounds.x + BOUND_REDUCE;
        const max = bounds.x + width - BOUND_REDUCE;

        const changeX = Phaser.Math.Clamp(dragX, min, max);
        gameObject.x = changeX;
        gameObject.y = originY;


        const totalChange = (this.analogContainerWidth / 2) - BOUND_REDUCE;
        const difference = changeX - this.analogContainerOriginX;
        // const 
        const playerVelocityX = (difference / totalChange) * this.playerMaxVelocity
        this.player.setVelocity(playerVelocityX, 0)
    }

    anaglogDragEnd(pointer, gameObject) {
        gameObject.setPosition(this.analogContainerOriginX, this.analogContainerOriginY);
        this.player.setVelocity(0, 0)
    }

    keyRelease() {
        this.analog.setPosition(this.analogContainerOriginX, this.analogContainerOriginY);
        this.player.setVelocity(0, 0)
    }

    keyboardRight() {
        const bounds = this.analogContainer.getBounds();
        const width = this.analogContainerWidth;
        const originY = this.analogContainerOriginY;

        const BOUND_REDUCE = 40
        const max = bounds.x + width - BOUND_REDUCE;

        this.analog.setPosition(max, originY);
        this.player.setVelocity(this.playerMaxVelocity, 0); // Stop movement at the boundary
    }

    keyboardLeft() {
        const bounds = this.analogContainer.getBounds();
        const originY = this.analogContainerOriginY;

        const BOUND_REDUCE = 40
        const min = bounds.x + BOUND_REDUCE;

        this.analog.setPosition(min, originY);

        this.player.setVelocity(-(this.playerMaxVelocity), 0);
    }

    pauseGame() {
        this.scene.pause(); // This pauses the current scene
    }

    gameOver() {
        if (!this.scene.isActive(this.scene.key)) {
            console.warn("Cannot trigger game over: Scene is not active.");
            return;
        }

        this.matter.world.pause()
        this.input.keyboard.enabled = false;

        this.sound.stopAll();
        this.gameOverSound?.play()


        this.gameoverBackground = this.add.image(this.bgOriginX, this.bgOriginY, 'bg-gameover');
        this.gameoverBackground.setDisplaySize(
            this.bgWidth, this.bgHeight
        )

        // Pause the fireGroup (stop movement)
        this.fireGroup.forEach(fire => fire?.setVelocity(0, 0));
        this.enemyGroup.forEach(enemy => enemy?.setVelocity(0, 0));

        // Stop timer event
        if (this.enemyRespawnEvent) {
            this.enemyRespawnEvent.remove(); // Remove the timer
        }

        if (this.analog) {
            this.analog.disableInteractive();
            this.analog.setPosition(this.analogOriginX, this.analogOriginY)
        }


        this.player.setVelocity(0, 0);

        this.time.delayedCall(4000, () => {
            this.gameoverBackground.destroy()
            this.scene.restart(this.scene.key); // Restart cleanly
        });
    }

    resize(gameSize) {
        // this.background.setPosition(gameSize.width / 2, gameSize.height / 2)
        // this.background.setDisplaySize(
        //     Math.min(gameSize.width - 30, 400),
        //     Math.min(gameSize.height - 30, 400)
        // )
    }
}

export default GameScene
